import { useEffect, useState } from 'react';

import { useCatalogValueList } from '../../configuration/catalogs/hooks/useCatalogValueList';
import { catalogName } from '../../configuration/catalogs/models/Catalog';

import { taxReturnService } from './services/taxReturn.service';
import { type TaxReturn } from './types';

export const useCountries = () => {
  return useCatalogValueList(catalogName.countries);
};

export const useGetTaxReturnById = (id: string) => {
  const [taxReturn, setTaxReturn] = useState<TaxReturn>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    if (!id) {
      return;
    }

    const loadTaxReturn = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const result = await taxReturnService.getTaxReturn(id);

        setTaxReturn(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    loadTaxReturn();
  }, [id]);

  return {
    taxreturn: taxReturn,
    loading,
    error
  };
};
